module.exports = __webpack_public_path__ + "img/image100.8b3bb967.png";